<!-- WRAP IF DISPLAY AS TEXT -->
@switch (displayType) {
  @case (layoutDisplayType.DISPLAY_AS_TEXT) {
    <div [ngClass]="{'lm-is-single-line': isSingleLine, 'lm-parent-is-number-label': isNumberLabel}">
      <ng-container *ngTemplateOutlet="richtextComponentTemplate"></ng-container>
    </div>
  }
  @case (layoutDisplayType.PLAIN) {
    @if (isNumberLabel) {
      <div class="lm-parent-is-number-label">
        <ng-container *ngTemplateOutlet="richtextComponentTemplate"></ng-container>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="richtextComponentTemplate"></ng-container>
    }
  }
}

<ng-template #richtextComponentTemplate>
  @if (label) {
    <label
      [attr.for]="id"
      soho-label
        [required]="required$ | async"
      lm-label
        [layoutField]="field"
        [parentIsFormLayout]="parentIsFormLayout"
        [personalize]="personalize"
      lm-text-style
        [textStyle]="field?.label?.textStyle"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
    </label>
  }
  <div
      lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [disableFieldOptions]="disableFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      lm-layout-util
        [hideWhiteSpace]="shouldHideWhiteSpace"
        [isEditableRichText]="displayType === layoutDisplayType.PLAIN"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'bottom'"
        [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
    @switch (displayType) {
      @case (layoutDisplayType.PLAIN) {
        <div [ngClass]="{'field' : true, 'field-options-width-override': !displayAsText, 'lm-richtext-block' : !displayAsText, 'lm-richtext-grow': displayAsText}">
          <!--LMCLIENT-33701: adding hidden span because it is not valid to associate label with div which is not a labelable element.-->
          @if (!displayAsText) {
            <span 
              id="{{id}}_label"
              class="label hidden"
            >{{(triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) || bindId}}</span>
          }
          <div
               #Input
               [ngClass]="fieldClassesString"
               [attr.name]="id"
               [attr.id]="id"
               [attr.bindId]="bindId"
               class="lm-richtext-content"
               [attr.tabindex]="isInAccessibilityMode ? 0 : (readOnly$ | async) ? -1 : null"
               soho-editor
               (generateai)="onGenerateAIButtonClicked($event)"
               [rows]="rows"
               [excludeButtons]="excludeButtons"
               soho-alert
               soho-trackdirty
               [attr.aria-describedby]="fieldDescriptionId"
               (dirty)="onDirty($event)"
               (pristine)="onPristine($event)"
               (afterResetDirty)="onAfterResetDirty($event)"
               soho-input-validate
               (error)="onError($event)"
               (valid)="onValid($event)"
               (blur)="onBlur($event)"
               (change)="onRichTextChange()"
          ></div>
        </div>
      }
      @case (layoutDisplayType.DISPLAY_AS_TEXT) {
        <div [ngClass]="{'field' : true, 'field-options-width-override': !displayAsText, 'lm-richtext-block' : !displayAsText, 'lm-richtext-grow': displayAsText}">
          <!-- See also lm-text-soho.component.html for form text with hasRichTextVars -->
          <div
               [ngClass]="fieldClassesString"
               class="lm-richtext-content is-preview hide-white-space"
               [attr.name]="id"
               [attr.id]="id"
               [attr.bindId]="bindId"
               [innerHTML]="triggerValueChange | async | richText:richTextValue"
               soho-editor
               [preview]="true"
               soho-alert></div>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
  }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}